<ng-template #content let-modal class="history-modal">
  <div class="modal-header">
    <div class="col-md-12">
      <span class="modal-title">
        {{ historyModalTitle }}
      </span>
      <button class="btn pull-right" (click)="closeModal()">
        <i class="fa fa-times"></i>
      </button>
    </div>
  </div>
  <div class="modal-body">
    <app-paginator
      [length]="app.history.historyDocs.length"
      [index]="app.paginator.focus"
      (focus)="app.paginator.focus = $event"
    ></app-paginator>
    @if (app.unlockedId == null) {
      <div>
        @for (
          historyItem of app.paginator.getPage(app.history.historyDocs);
          track historyItem
        ) {
          <div>
            <div class="history-box col-sm-12">
              <!-- CREATE DOCS HISTORY -->
              @if (historyItem.action === "create") {
                <div class="col-sm-12 create-line">
                  <span class="user-name">{{
                    app.users.getOptionName(historyItem.user)
                  }}</span>
                  <span>
                    {{ app.history.displayCreateMessage(historyItem) }}
                  </span>
                  <span>{{ app.text.history.on }}</span>
                  <span class="create-date">
                    {{ app.history.getDateformat(historyItem.create_time) }}
                  </span>
                </div>
              }
              <!-- DELETE DOCS HISTORY -->
              @if (historyItem.action === "delete") {
                <div>
                  <div class="col-sm-12 delete-line">
                    <span class="user-name">{{ historyItem.user }}</span>
                    <span>
                      {{ app.history.deleteDocText(historyItem) }}
                    </span>
                    <span>{{ app.text.history.on }}</span>
                    <span class="create-date"
                      >{{ app.history.getDateformat(historyItem.create_time) }}
                    </span>
                  </div>
                </div>
              }
              <!-- TRANSFERRED TO ANOTHER SYSTEM - the sending system names the user -->
              @if (historyItem.action === "transferOut") {
                <div class="col-sm-12 create-line">
                  <span class="user-name">{{
                    app.users.getOptionName(historyItem.user)
                  }}</span>
                  <span>
                    {{ app.history.displayTransferMessage(historyItem) }}
                  </span>
                  <span>{{ app.text.history.on }}</span>
                  <span class="create-date">
                    {{ app.history.getDateformat(historyItem.create_time) }}
                  </span>
                </div>
              }

              <!-- ARRIVED FROM ANOTHER SYSTEM - written by the system, so no user -->
              @if (historyItem.action === "transferIn") {
                <div class="col-sm-12 create-line">
                  <span>
                    {{ app.history.displayTransferMessage(historyItem) }}
                  </span>
                  <span>{{ app.text.history.on }}</span>
                  <span class="create-date">
                    {{ app.history.getDateformat(historyItem.create_time) }}
                  </span>
                </div>
              }

              <!-- EDIT DOCS HISTORY -->
              @if (historyItem.action === "edit") {
                <div>
                  <div class="col-sm-12 edit-line">
                    <!-- Display user name only in cases which we need a different message than default -->
                    @if (!app.history.displayEditDefaultMessage(historyItem)) {
                      <span>
                        <span class="user-name">{{ historyItem.user }}</span>
                      </span>
                    }
                    <span>
                      {{ app.history.displayEditMessage(historyItem) }}
                    </span>
                    <!-- Display date only in cases which we need a different message than default -->
                    @if (!app.history.displayEditDefaultMessage(historyItem)) {
                      <span>
                        <span>{{ app.text.history.on }}</span>
                        <span class="create-date"
                          >{{
                            app.history.getDateformat(historyItem.create_time)
                          }}
                        </span>
                      </span>
                    }
                  </div>
                  @if (app.history.displayEditDefaultMessage(historyItem)) {
                    <table class="table">
                      <thead>
                        <tr>
                          <td class="col-sm-2">{{ app.text.history.date }}</td>
                          <td class="col-sm-2">
                            {{ app.text.history.userName }}
                          </td>
                          <td class="col-sm-2">
                            {{ app.text.history.fieldName }}
                          </td>
                          <td class="col-sm-3">
                            {{ app.text.history.oldValue }}
                          </td>
                          <td class="col-sm-3">
                            {{ app.text.history.newValue }}
                          </td>
                        </tr>
                      </thead>
                      <tbody>
                        @for (
                          changedField of historyItem.data.operations;
                          track changedField;
                          let i = $index
                        ) {
                          <tr>
                            <td class="col-sm-2">
                              @if (i === 0) {
                                <span>
                                  {{
                                    app.history.getDateformat(
                                      historyItem.create_time
                                    )
                                  }}
                                </span>
                              }
                            </td>
                            <td class="col-sm-2">
                              @if (i === 0) {
                                <span>
                                  {{ historyItem.user }}
                                </span>
                              }
                            </td>
                            <td class="col-sm-2">
                              <span>
                                {{
                                  app.history.getFieldName(
                                    historyItem.docType,
                                    changedField.property
                                  )
                                }}
                              </span>
                            </td>
                            <td class="col-sm-3">
                              {{
                                app.history.getText(
                                  historyItem.docType,
                                  changedField.property,
                                  changedField.oldValue
                                )
                              }}
                            </td>
                            <td class="col-sm-3">
                              {{
                                app.history.getText(
                                  historyItem.docType,
                                  changedField.property,
                                  changedField.newValue
                                )
                              }}
                            </td>
                          </tr>
                        }
                      </tbody>
                    </table>
                  }
                </div>
              }
            </div>
          </div>
        }
      </div>
    }
  </div>
</ng-template>
